(function() {
  "use strict";

  SeriesTraineesCtrl.$inject = ['$scope', '$timeout', 'seriesTraineesResource', '$route', 'gridFormatters', 'mtypes', 'gridUtils', '$filter', 'userGridUtils', 'compositeSearchData', 'courseSearch', 'trackingService', '$location', 'notificationService', 'trainerPrivilege', '$window', 'courseTraineesResource'];
  angular
    .module('trainerWebApp.controllers')
    .controller('SeriesTraineesCtrl', SeriesTraineesCtrl);

  function SeriesTraineesCtrl($scope, $timeout, seriesTraineesResource, $route, gridFormatters, mtypes, gridUtils, $filter,
                              userGridUtils,compositeSearchData, courseSearch, trackingService, $location, notificationService,
                              trainerPrivilege, $window, courseTraineesResource) {

    var seriesId = $scope.seriesId = $route.current.params.seriesId;
    if (!$scope.resolvedData.trainees) return;

    $scope.userRole = trainerPrivilege.roles();
    $scope.hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);
    $scope.courseAlteredAfterSnapshot = false;

    var includeSelectCheckbox = $scope.userRole.canDropTrainees || $scope.userRole.canExtendTraineeDeadlines ||
      $scope.userRole.canRemindTrainees || $scope.userRole.canResetTrainees || $scope.userRole.canUpdateTraineesInSeries;

    //TODO: remove hasQuizes when we move to newSeriesFeature
    var courseCount = $scope.resolvedData.coursesCount;
    var seriesHasQuizzes = $scope.resolvedData.hasQuizzes;
    var seriesSettings = $scope.resolvedData.seriesSettings;
    var trainees = mapTrainees($scope.resolvedData.trainees);

    function mapTrainees(trainees) {
      $scope.hasUsersWhoCanBeUpdated = _.where(trainees, {canUpdateSeries: true}).length > 0;
      $scope.courseAlteredAfterSnapshot = false;

      return _.map(trainees, function (trainee) {
        trainee.courseCount = courseCount;
        trainee.hasUsersWhoCanBeUpdated = $scope.hasUsersWhoCanBeUpdated;
        trainee.seriesHasQuizzes = seriesHasQuizzes;
        trainee.name = trainee.lastName + ', ' + trainee.firstName;
        if($scope.hasNewSeriesFeature) {
          if (trainee.completed < seriesSettings.contentModified) {
            trainee.contentModifiedAfterCompletion = true;
            $scope.courseAlteredAfterSnapshot = true;
          }
        }
        return trainee;
      });
    }

    var seriesGroups = $scope.resolvedData.groups;
    var coursesCount = $scope.resolvedData.coursesCount;
    $scope.coursesAlteredWhileActive = $scope.resolvedData.coursesAlteredWhileActive;
    $scope.hasDeadline = $scope.resolvedData.seriesSettings.hasDeadline;
    $scope.showBulkDeadlineButton = $scope.hasDeadline && $scope.userRole.canExtendTraineeDeadlines;
    $scope.traineeGroups = getGroupSelection();

    $scope.resolvedData = null;
    $scope.groupSelect = "";
    $scope.traineeCount = trainees.length;
    $scope.coursesCount = coursesCount;
    $scope.bulkDeadlineDate = null;
    $scope.bulkDeadlineDateFormatted = null;
    $scope.noCoursesMessage = "To invite Trainees, first add courses to your Series on the Manage tab.";
    $scope.overridePlaceholder = 'Search by name, email or group';

    var traineesToDrop = [];
    var traineesToRemind = [];
    var traineesToReinvite = [];
    var traineesToSetDeadline = [];
    var traineesToUpdate = [];

    if(!$scope.userRole.canEditCourses)
      $scope.noCoursesMessage = "Courses must be added to this series prior to inviting Trainees. Contact the site's administrator for assistance. ";

    var gridCommands = $scope.gridCommands = {};
    var remindButtonStates = {
      "Disabled": {remindBtnText: "Remind", enabled: false},
      "Remind": {remindBtnText: "Remind", enabled: true},
      "Reminded": {remindBtnText: "Reminded", enabled: false}
    };

    var searchData = compositeSearchData.getSearchData();

    var searchFilter = null;

    if (searchData) {
      if (searchData.name == 'group') {
        searchFilter = userGridUtils.filter.createFilter(
          userGridUtils.filter.byGroupMembership,
          [searchData.id]);
      } else if (searchData.name == 'user') {

        var user = _.find(trainees, function (t) {
          return t.id == searchData.id;
        });

        if (user.email) {
          searchFilter = userGridUtils.filter.createFilter(
            userGridUtils.filter.byEmail,
            [user.email]);

          searchData.name = "email";
          searchData.id = user;
        } else if (user.username) {
          searchFilter = userGridUtils.filter.createFilter(
            userGridUtils.filter.byUsername,
            [user.username]);

          searchData.name = "username";
          searchData.id = user;
        }
      }

      compositeSearchData.clearSearchData();
    }

    function setupSearch() {
      $scope.searchSettings = courseSearch.createSearchSettings({
        filterHasResults:filterHasResults,
        gaPageName:trackingService.pages.seriesTrainees.name,
        groups:seriesGroups,
        setFilter:setSearchFilter});
    }
    setupSearch();

    function filterHasResults(searchFilter) {
      return _.some($scope.getVisibleGridItems(), function (u) {
        return filterer(u, $scope.filterData) && searchFilter(u._parent || u);
      });
    }

    function setSearchFilter(filter) {
      searchFilter = filter;
      updateFilter();
    }

    $scope.groupSelected = function () {
      updateFilter();
    };

    function getGroupSelection() {
      return _.map(seriesGroups, function (item) {
        return {name: item.name, id: item.id, traineeIds: item.traineeIds};
      });
    }

    function getGridColumns() {
      var columns = [
        {id: "name", name: "Name", field: "name", width: 330, cssClass: "cell-title", headerCssClass: "header-column-first", formatter: gridFormatters.traineeNameFormatter, sortable: true},
        {id: "email", name: "Email", field: "email", width: 330, headerCssClass: "header-column", formatter: gridFormatters.traineeEmailFormatter, sortable: true},
        {id: "status", name: "Status", field: "status", minWidth: 180, maxWidth: 180, headerCssClass: "header-column", formatter: gridFormatters.traineeSeriesStatusFormatter, sortable: true, sorter: statusSorter}
      ];

      var someTraineesHasDeadline = _.some(trainees, function (t) {
        return t.completionDeadline;
      });

      if ($scope.hasDeadline || someTraineesHasDeadline) {
        columns.push({id: "completionDeadline", name: "Deadline", field: "completionDeadline", minWidth: 120, headerCssClass: "header-column", formatter: gridFormatters.deadlineFormatter, sortable: true, hasDeadline: $scope.hasDeadline});
      }

      columns.push({id: "invited", name: "Invited", field: "invited", minWidth: 126, headerCssClass: "header-column", formatter: gridFormatters.inviteFormatter, sortable: true});

      if($scope.isUsernameEnabled) {
        columns.splice(2,0,{id: "username", name: "Username", field: "username", minWidth: 80, headerCssClass: "header-column", sortable: true  });
      }
      return columns;
    }

    $scope.gridInfo = {
      options: {editable: false,
        enableCellNavigation: false,
        asyncEditorLoading: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        forceSyncScrolling: trainees.length < 500,
        multiColumnSort: true
      },
      columns: getGridColumns(),
      onRowsChanged: onRowsChanged,
      onRowCountChanged: onRowCountChanged,
      onSelectedRowsChanged: onSelectedRowsChanged,
      includeSelectCheckbox: includeSelectCheckbox,
      onClick: onRowClick,
      rowMetadataProvider: rowMetadataProvider,
      filterFn: filterer,
      checkboxSelectionFormatter: checkboxSelectionFormatter,
      data: []
    };

    function checkboxSelectionFormatter(row, cell, value, columnDef, dataContext) {
      if (dataContext && dataContext.metaType != "" && dataContext.metaType) return;

      var selectedRows = gridCommands.getSelectedRows();
      var checked = !!~selectedRows.indexOf(row);
      return checked ? "<input type='checkbox' checked='checked'>" : "<input type='checkbox'>";
    }

    var selectedIds = [];

    function onSelectedRowsChanged(args, value) {
      selectedIds = value;
      $scope.selectedRowsCount = selectedIds.length;
      updateRemindBtnState();
      updateDropBtnState();
      updateReinviteBtnState();
      updateSetDeadlineBtnState();
      updateUpdateBtnState();
    }

    $scope.gridData = trainees.sort(userGridUtils.sort.byPersonName);

    $scope.filteredTraineeCount = $scope.gridData.length;

    function rowMetadataProvider(row) {
      var item = this.getItem(row)
      if (!item) return {cssClasses: 'collapsed'};

      var obj = {
        rows: {},
        cssClasses: ''
      };

      if (!item.metaType) {
        if (gridCommands.hasChildren(item)) {
          obj['cssClasses'] = 'expanded';
        } else if (coursesCount) {
          obj['cssClasses'] = 'collapsed';
        }
        return obj;
      }

      obj['cssClasses'] = item.metaType;
      return obj;
    }

    function statusSorter(a, b) {
      return userGridUtils.sort.byCourseStatus(a, b);
    }

    function filterer(itemToFilter, args) {
      if (!args) return true;
      if (!args.courseStateCriteria && !args.searchFilter)
        return true;

      var item = itemToFilter._parent || itemToFilter;

      if (args.searchFilter && !args.searchFilter(item)) return false;

      if (args.courseStateCriteria === 'all') return true;

      if (item.status === mtypes.courseStateStatus.invited)
        return args.courseStateCriteria === 'invited';
      if (item.status === mtypes.courseStateStatus.started)
        return args.courseStateCriteria === 'progress';
      if (item.status === mtypes.courseStateStatus.completed) {
        if (args.courseGradeCriteria === 'all')
          return args.courseStateCriteria === 'completed';
        if(item.passed)
          return args.courseStateCriteria === 'completed' && args.courseGradeCriteria === 'passed';
        else
          return args.courseStateCriteria === 'completed' && args.courseGradeCriteria === 'failed';
      }
      if (item.status === mtypes.courseStateStatus.missedCompletionDeadline)
        return args.courseStateCriteria === 'missed';
      return false;
    }

    var viewData = [];

    function onRowCountChanged(args, items) {
      //filter out expanded courses
      viewData = _.filter(items, function (item) {
        return !item._parent;
      });
      $scope.filteredTraineeCount = viewData.length;
      updateRemindBtnState();
      updateDropBtnState();
      updateReinviteBtnState();
      updateSetDeadlineBtnState();
      updateUpdateBtnState();
    }

    function onRowsChanged(args, items) {
      viewData = _.filter(items, function (item) {
        return !item._parent;
      });
      updateRemindBtnState();
      updateDropBtnState();
      updateReinviteBtnState();
      updateSetDeadlineBtnState();
      updateUpdateBtnState();
    }

    function onRowClick(item, targetClasses, target) {
      if (target.type == "checkbox") return;

      if (targetClasses.indexOf('action-retake') !== -1) {
        return requestSeriesCourseReset(item);
      }

      if (targetClasses.indexOf('action-complete') !== -1) {
        // Pop-up to set the score if course has quizzes. Don't actually call the endpoint to complete the course.
        // This way if they hit cancel on the input score dialog the course isn't completed.
        if (item.quizScoresMatter)
          return requestSeriesCourseSetScore(item);

        return requestSeriesCourseComplete(item);
      }

      if (targetClasses.indexOf('action-set-score') !== -1) {
        return requestSeriesCourseSetScore(item);
      }

      if (targetClasses.indexOf('action-setDeadline') !== -1 ||
        targetClasses.indexOf('action-extendDeadline') !== -1) {
        return gridUtils.showDatePicker(target, item, onDeadlineChanged);
      }

      // why is this here?
      if (item.metaType) return;

      if (targetClasses.indexOf('action-remind') !== -1) {
        if (!item.pokeRemindEnabled) return;
        return doRemind(item);
      }

      if (targetClasses.indexOf('action-delete') !== -1) {
        if (!item.canBeDropped) return;
        return showDropConfirmation(item);
      }

      if (targetClasses.indexOf('action-reinvite') !== -1) {
        return requestReset(item);
      }

      if (targetClasses.indexOf('action-update') !== -1) {
        return requestUpdate(item);
      }

      if (!coursesCount) return;

      if (gridCommands.hasChildren(item)) {
        gridCommands.removeChildRows(item);
      } else {
        var courseHeader = {
          id: 'loading' + item.id,
          name: 'Course',
          email: 'Status',
          status: 'Score',
          invited: $scope.userRole.canResetTrainees ? 'Action' : '',
          metaType: 'courseHeaderRow'
        };

        seriesTraineesResource.getAllSeriesCoursesForTrainee(seriesId, item.id, function (courseStates) {
          var rows = [courseHeader];
          _.each(courseStates, function (courseState, index) {
            rows.push({
              id: courseState.id,
              courseId: courseState.courseId,
              name: courseState.courseName,
              email: courseState.status, //put status in email column for expanded row
              status: {
                courseStateStatus: courseState.status,
                grade: courseState.finalGrade,
                cert: courseState.certificateUrl,
                gradeStatus: courseState.gradeStatus,
                hasQuizzes: courseState.hasQuizzes
              },
              statusDate: courseState.statusDate,
              canRetake: courseState.canRetake,
              metaType: 'courseRow' + (index == courseStates.length - 1 ? ' last' : ''),
              addedAfterCompletion: courseState.addedAfterCompletion,
              failEnforcedNoRetake: courseState.failEnforcedNoRetake,
              canResetTrainees: $scope.userRole.canResetTrainees,
              canMarkTraineeCompleted: $scope.userRole.canMarkTraineeCompleted,
              canSetTraineeScore : $scope.userRole.canSetTraineeScore,
              removed: courseState.removed,
              contentModifiedAfterCompletion: item.contentModifiedAfterCompletion,
              courseType: courseState.courseType,
              quizScoresMatter: courseState.quizScoresMatter,
              hadQuiz: courseState.hadQuiz
            });
          });
          gridCommands.setChildRows(item, rows);
        });
      }
    }

    function doRemind(trainees, cb) {
      var bulkAction = true;
      if(!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids =_.pluck(trainees, 'id');
      seriesTraineesResource.pokeRemindSeriesTrainees($scope.seriesId, ids, function (result) {
        if (bulkAction) {
          _.each(trainees, function (item) {
            item.pokeRemindEnabled = false;
          });
          gridCommands.updateAllRows();
        } else {
          trainees[0].pokeRemindEnabled = false;
          gridCommands.updateRow(trainees[0]);
        }

        updateRemindBtnState();
        if (bulkAction)
          gridCommands.cleanSelection();
        (cb || angular.noop)();
      }, function (error) {
        (cb || angular.noop)();
      });
    }

    function doDrop(trainees, cb) {
      var bulkAction = true;
      if(!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids = _.pluck(trainees, 'id');
      seriesTraineesResource.uninviteSeriesTrainees($scope.seriesId, ids, function (result) {
        (cb || angular.noop)();
        refreshData();
      }, function (error) {
        (cb || angular.noop)();
      });
    }

    function doSetDeadline(trainees, deadline, cb) {
      var bulkAction = true;
      if(!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids = _.pluck(trainees, 'id');
      seriesTraineesResource.updateDeadline($scope.seriesId, ids, deadline, function (result) {
        refreshData();
        if (bulkAction)
          gridCommands.cleanSelection();
        (cb || angular.noop)();
      }, function (error) {
        (cb || angular.noop)();
      });
    }

    function refreshData() {
      seriesTraineesResource.traineesSetup(seriesId, function (result) {
        result.trainees = _.map(result.trainees, function (trainee) {
          trainee.courseCount = result.coursesCount;
          trainee.name = trainee.lastName + ', ' + trainee.firstName;
          return trainee
        });

        trainees = mapTrainees(result.trainees);
        $scope.gridData = trainees.sort(userGridUtils.sort.byPersonName);
        $scope.traineeCount = trainees.length;
        seriesGroups = result.groups;
        $scope.traineeGroups = getGroupSelection();
        updateRemindBtnState();
        updateDropBtnState();
        updateSetDeadlineBtnState();
        updateUpdateBtnState();
      });
    }

    function updateFilter() {
      if($scope.courseStateCriteria !== "completed") $scope.courseGradeCriteria = "all";
      $scope.filterData = {
        courseStateCriteria: $scope.courseStateCriteria,
        courseGradeCriteria: $scope.courseGradeCriteria,
        searchFilter: searchFilter
      };
      $scope.showGradeCriteria = $scope.courseStateCriteria === 'completed';
    }

    function showDropConfirmation(item) {
      $scope.$broadcast('uninviteTraineeEvent', item);
    }

    $scope.courseStateCriteria = $location.search()['f'] ? $location.search()['f'] : 'all';
    $scope.courseGradeCriteria = $location.search()['gf'] ? $location.search()['gf'] : 'all';
    $scope.showGradeCriteria = true;

    $scope.$watch('courseStateCriteria', function (item) {
      if (!item) return;
      updateFilter();
    });

    $scope.$watch('courseGradeCriteria', function (item) {
      if (!item) return;
      updateFilter();
    });

    $scope.$on('uninviteTraineesConfirmEvent', function (event, trainee, cb) {
      event.stopPropagation();
      doDrop(_.isEmpty(trainee) ? traineesToDrop : trainee, cb);
    });

    $scope.$on('remindTraineesConfirmEvent', function (event, trainee, cb) {
      event.stopPropagation();
      doRemind(_.isEmpty(trainee) ? traineesToRemind : trainee, cb);
    });

    $scope.$on('setDeadlineTraineesConfirmEvent', function (event, notUsed, cb) {
      event.stopPropagation();
      doSetDeadline(traineesToSetDeadline, $scope.bulkDeadlineDate, cb);
      var notification = {message: 'Deadline updated for ' + $scope.traineesToSetDeadlineCnt +' trainee(s).', pageToShow: 'Series', close: true, displayOrder: 2}
      notificationService.setNotification(notification);
      $timeout(function() {
        notificationService.removeNotification(notification);
      }, 5000);
    });

    function updateRemindBtnState() {
      $scope.bulkRemindState = remindButtonStates.Disabled;
      traineesToRemind = [];

      if (!$scope.traineeCount || !$scope.coursesCount || $scope.courseStateCriteria == 'completed' ||
        $scope.courseStateCriteria == 'missed')
        return;

      _.each(viewData, function (trainee) {
        if (trainee.pokeRemindEnabled && selectedIds.indexOf(trainee.id) != -1) {
          $scope.bulkRemindState = remindButtonStates.Remind;
          traineesToRemind.push(trainee);
        }
      });
      $scope.traineesToRemindCnt = traineesToRemind.length;
    }

    function updateSetDeadlineBtnState() {
      $scope.bulkSetDeadlineEnabled = false;
      traineesToSetDeadline = [];

      if ($scope.courseStateCriteria == 'completed') return;

      _.each(viewData, function (trainee) {
        if (trainee.status != mtypes.courseStateStatus.completed && ~selectedIds.indexOf(trainee.id)) {
          $scope.bulkSetDeadlineEnabled = true;
          traineesToSetDeadline.push(trainee);
        }
      });
      $scope.traineesToSetDeadlineCnt = traineesToSetDeadline.length;
    }

    function updateReinviteBtnState() {
      $scope.bulkReinviteEnabled = false;
      traineesToReinvite = [];

      _.each(viewData, function (trainee) {
        if (~selectedIds.indexOf(trainee.id)) {
          $scope.bulkReinviteEnabled = true;
          traineesToReinvite.push(trainee);
        }
      });

      $scope.traineesToReinviteCnt = traineesToReinvite.length;
    }

    function updateUpdateBtnState() {
      $scope.bulkUpdateEnabled = false;
      traineesToUpdate = [];

      _.each(viewData, function (trainee) {
        if (trainee.canUpdateSeries && ~selectedIds.indexOf(trainee.id)) {
          $scope.bulkUpdateEnabled = true;
          traineesToUpdate.push(trainee);
        }
      });

      $scope.traineesToUpdateCnt = traineesToUpdate.length;
    }

    function updateDropBtnState() {
      $scope.bulkDropEnabled = false;
      traineesToDrop = [];

      if ($scope.courseStateCriteria == 'completed' || !$scope.coursesCount) return;

      _.each(viewData, function (trainee) {
        if (trainee.canBeDropped && selectedIds.indexOf(trainee.id) != -1) {
          $scope.bulkDropEnabled = true;
          traineesToDrop.push(trainee);
        }
      });

      $scope.traineesToDropCnt = traineesToDrop.length;
    }

    $scope.bulkDropText;
    $scope.$watch('traineesToDropCnt', function (value) {
      $scope.bulkDropText = 'Drop';
      if (value > 0)
        $scope.bulkDropText += ' (' + value + ')';
    });

    $scope.bulkRemindText;
    $scope.$watch('traineesToRemindCnt', function (value) {
      $scope.bulkRemindText = 'Remind';
      if (value > 0)
        $scope.bulkRemindText += ' (' + value + ')';
    });

    $scope.bulkReinviteText;
    $scope.$watch('traineesToReinviteCnt', function (value) {
      $scope.bulkReinviteText = 'Reset';
      if (value > 0)
        $scope.bulkReinviteText += ' (' + value + ')';
    });

    $scope.bulkUpdateText;
    $scope.$watch('traineesToUpdateCnt', function (value) {
      $scope.bulkUpdateText = 'Update';
      if (value > 0)
        $scope.bulkUpdateText += ' (' + value + ')';
    });

    $scope.bulkDeadlineText;
    $scope.$watch('traineesToSetDeadlineCnt', function (value) {
      $scope.bulkDeadlineText = 'Set Deadline';
      if (value > 0)
        $scope.bulkDeadlineText += ' (' + value + ')';
    });

    $scope.getTraineesCount = function () {
      return ' (' + ($scope.traineesToDropCnt || 0) + ')';
    };

    $scope.$on('$destroy', function () {
      // cleanup
    });

    $scope.getAddTraineesUrl = function () {
      $scope.currentTab = "addExistingTrainees";
      return $scope.coursesCount ? '#/TMS/Series/' + $scope.seriesId + '/addExistingTrainees' : null;
    };

    $scope.getNewUserUrl = function () {
      $scope.currentTab = "addNewUser";
      return $scope.coursesCount ? '#/TMS/Series/' + $scope.seriesId + '/addNewUser' : null;
    };

    $scope.getImportXlsUrl = function () {
      $scope.currentTab = "importXls";
      return $scope.coursesCount ? '#/TMS/Series/' + $scope.seriesId + '/importXls' : null;
    };

    $scope.getAddTraineesFromYammerUrl = function () {
      $scope.currentTab = "addYammerUsers";
      return $scope.coursesCount ? '#/TMS/Series/' + $scope.seriesId + '/addYammerUsers' : null;
    };

    $scope.broadcastTraineesToDrop = function () {
      $scope.$broadcast('traineesToDropEvent', $scope.traineesToDropCnt);
    };

    $scope.broadcastTraineesToRemind = function () {
      $scope.$broadcast('traineesToRemindEvent', $scope.traineesToRemindCnt);
    };

    // series/course reset event
    function requestSeriesCourseReset(item) {
      if (!item._parent) return;

      if(shouldExtendDeadline(item)) {
        var d = new Date();
        item.extensionDate = $filter('date')(d.setDate(d.getDate() + 7), 'dd-MMM-yyyy');
      }

      $scope.$broadcast('seriesCourseResetRequested', item);
    }

    function requestSeriesCourseComplete(trainee, cb) {
      courseTraineesResource.completeCourseTrainees(trainee.courseId, [trainee._parent.id], function (result) {
        refreshData();
        (cb || angular.noop)();
      }, function (error) {
        (cb || angular.noop)();
      });
    }

    function requestSeriesCourseSetScore(trainee, cb) {
      var scoreText = prompt('Enter trainee\'s score');

      if (scoreText != null) {
        var score = parseInt(scoreText);
        if (!isNaN(score) && score >= 0 && score <= 100) {
          courseTraineesResource.setTraineeScore(trainee.courseId, trainee._parent.id, score, function (result) {
            refreshData();
            (cb || angular.noop)();
          }, function (error) {
            (cb || angular.noop)();
          });
        }
      }
    }

    function shouldExtendDeadline(item) {
      var series = item._parent;
      if (!seriesSettings && seriesSettings.hasDeadline)
        return false;
      if (!series.completionDeadline)
        return false;

      if(new Date() < Date.parse(series.completionDeadline))
        return false;

      return true;
    }

    $scope.$on('seriesCourseResetConfirmed', function (event, trainee, cb) {
      event.stopPropagation();
      doSeriesCourseReset(trainee, cb);
    });

    function doSeriesCourseReset(trainee, cb) {
      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      seriesTraineesResource.resetSeriesCourseTrainee(
        $scope.seriesId,
        trainee.courseId,
        trainee._parent.id,
        dateString,
        function () {
          trainee.email = mtypes.courseStateStatus.invited;
          trainee.canRetake = false;
          trainee.status.grade = null;
          trainee.status.gradeStatus = mtypes.gradeStatus.none;
          trainee._parent.status = mtypes.courseStateStatus.invited;

          gridCommands.updateItem(trainee.id, trainee);
          gridCommands.updateItem(trainee._parent.id, trainee._parent);
          refreshData();
          (cb || angular.noop)();
        },
        function (error) {
          (cb || angular.noop)();
        }
      );
    }

    function filterByEmail(user) {
      var field = _.find($scope.searchSettings.fields, function (f) {
        return f.name == 'email';
      });

      var searchItem = {
        id: field.label + "|" + user.id,
        label: field.label,
        text: user.email,
        field: field,
        dataForFilter: user.email,
        track: field.track
      };

      compositeSearchData.setSearchItem(searchItem);
    }

    // series reset events
    function requestReset(item) {
      $scope.$broadcast('seriesResetRequested', item);
    }
    $scope.$on('seriesResetConfirmed', function (event, trainee, cb) {
      event.stopPropagation();
      doSeriesReset(trainee, cb);
    });

    // bulk series reset events
    $scope.requestBulkReset = function () {
      $scope.$broadcast('seriesBulkResetRequested', $scope.traineesToReinviteCnt);
    };
    $scope.$on('seriesBulkResetConfirmed', function (event, notUsed, cb) {
      event.stopPropagation();
      doSeriesReset(traineesToReinvite, cb);
    });

    // series update events
    function requestUpdate(item) {
      traineesToUpdate = [item];
      $scope.$broadcast('seriesUpdateRequested', item, $scope.title.seriesTrainerEmail);
    }
    $scope.requestBulkUpdate = function () {
      $scope.$broadcast('seriesBulkUpdateRequested', $scope.traineesToUpdateCnt, $scope.title.seriesTrainerEmail);
    };
    $scope.$on('seriesBulkUpdateConfirmed', function (event, notUsed, cb) {
      event.stopPropagation();
      doSeriesUpdate(traineesToUpdate, cb);
    });

    function doSeriesUpdate(trainees, cb) {
      var bulkAction = true;
      if(!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids = _.pluck(trainees, 'id');
      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      seriesTraineesResource.updateSeriesTrainees($scope.seriesId, ids, dateString, function (result) {
        refreshData();
        if (bulkAction)
          gridCommands.cleanSelection();
        (cb || angular.noop)();
      }, function (error) {
        (cb || angular.noop)();
      });
    }

    function doSeriesReset(trainees, cb) {
      var bulkAction = true;
      if(!angular.isArray(trainees)) {
        bulkAction = false;
        trainees = [trainees];
      }

      var ids = _.pluck(trainees, 'id');
      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      seriesTraineesResource.resetSeriesTrainees($scope.seriesId, ids, dateString, function (result) {
        refreshData();
        if (bulkAction)
          gridCommands.cleanSelection();
        (cb || angular.noop)();
      }, function (error) {
        (cb || angular.noop)();
      });
    }

    function onDeadlineChanged(date, item) {
      date = new Date(date);
      gridCommands.updateRow(item);
      seriesTraineesResource.updateDeadline($scope.seriesId, [item.id], $filter('date')(date, 'yyyy-MM-dd'), refreshData);
      var notification = {message: 'Deadline updated for ' + item.name + '.', pageToShow: 'Series', close: true, displayOrder: 2};
      notificationService.setNotification(notification);
      $timeout(function() {
        notificationService.removeNotification(notification);
      }, 5000);
    }

    $scope.bulkSetDeadline = function (event) {
      $scope.bulkDeadlineDate = event.date.getUTCFullYear() + '-' + (event.date.getUTCMonth() + 1) + '-' + event.date.getUTCDate();
      $scope.bulkDeadlineDateFormatted = $filter('date')(new Date((event.date.getUTCMonth() + 1) + '/' + event.date.getUTCDate() + '/' + event.date.getUTCFullYear()), 'dd-MMM-yyyy');
      $scope.$broadcast('traineesToSetDeadlineEvent', $scope.traineesToSetDeadlineCnt, $scope.bulkDeadlineDateFormatted);
      $('#setDeadlinePopupTrigger').click();
    };

    $scope.showAddYammerUsers = function () {
      return $scope.yammerEnabled && !mfConfig.useGroupRestrictions;
    };

    if (searchData) {
      if (searchData.name == 'email')
        filterByEmail(searchData.id);
    }
  }

})();
